export default __webpack_public_path__ + "static/media/skullback.423bbc1f.gif";